export default "__VITE_ASSET__DS3Bccq6__"